import * as AT from '../constants/actionTypes'

/**
 * Profile reducer
 * @param {*} state 
 * @param {*} action 
 */
function upload(state = { }, action) {
	switch (action.type) {
		case AT.UPLOAD_FILE_STARTED:
			return Object.assign({}, state, {
				isProcessing: true,
				error: undefined
			})
    	case AT.UPLOAD_FILE_FAILED:
			return Object.assign({}, state, {
				isProcessing: false,
				error: action.payload.error
			})
    	case AT.UPLOAD_FILE_FINISHED:
			return Object.assign({}, state, {
				isProcessing: false,
				error: undefined
			})
		default:
			return state;
	}
}

export default upload;